import { Heading } from '@purpur/library';
import styled from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

export const AuthorDetailsContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('250')};
    max-width: 37.25rem;
`;

export const ImagePlaceholder = styled.div`
    opacity: 0.9;
    width: 3.5rem;
    height: 3.5rem;

    ${purpurMedia('md')`
        width: 8.93rem;
        height: 8.93rem;
    `};

    ${purpurMedia('lg')`
        width: 10.25rem;
        height: 10.25rem;
    `};
`;

export const ImagePlaceholderWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${getPurpurColor('backgroundToneOnTonePrimary')};

    svg path {
        stroke: ${getPurpurColor('brandWhite')};
    }
`;

export const ImageWrapper = styled.div`
    width: 4.75rem;
    height: 4.75rem;
    overflow: hidden;
    border-radius: ${getPurpurBorder('radiusFull')};
    flex-shrink: 0;

    ${purpurMedia('md')`
        width: 12.81rem;
        height: 12.81rem;
    `};

    ${purpurMedia('lg')`
        width: 16rem;
        height: 16rem;
    `};

    img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
`;

export const StyledAuthorDetails = styled.div`
    display: flex;
    gap: ${getPurpurSpacing('600')};
    align-items: center;

    > ${ImageWrapper} {
        display: none;
    }

    ${purpurMedia('md')`
        > ${ImageWrapper} {
            display: block;
        }
    `};
`;

export const Title = styled(Heading).attrs({ variant: 'title-500' })`
    flex-grow: 1;
`;

export const TitleWithImage = styled.div`
    display: flex;
    gap: ${getPurpurSpacing('200')};
    align-items: center;

    ${purpurMedia('md')`
        ${ImageWrapper} {
            display: none;
        }
    `};
`;

export const SocialButtons = styled.div`
    display: flex;
    gap: ${getPurpurSpacing('200')};
`;
